module.exports = __webpack_public_path__ + "static/media/GB.7c89983f.svg";